<template>
  <div>
    <PageHeader :title="$t('settings')"
                :breadcrumbs="[
                  {
                    route: null,
                    name: $t('menu_settings'),
                  },
                ]">
    </PageHeader>

    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">

            <!-- NAV TABS: the customer card's tab row - the top edge of the card, outside its
                 padding, so the open tab runs straight into the content below -->
            <CustomerTabsBar :tabs="visibleTabs"
                             :activeTab="activeTab"
                             @select="activeTab = $event"></CustomerTabsBar>

            <div class="card-body">

              <!-- TABS CONTENT -->

              <div class="row">
                <div class="tab-content">

                  <!-- WHATSAPP TAB -->

                  <div class="tab-pane"
                       :class="{ active: activeTab == 'orginizationSettings_whatsappTab' }">
                    <WhatsappTab></WhatsappTab>
                  </div>


                  <!-- INTEGRATIONS TAB (google sync, facebook, green invoice) -->

                  <div class="tab-pane"
                       :class="{ active: activeTab == 'orginizationSettings_googleTab' }">
                    <GoogleSettings></GoogleSettings>

                    <br>
                    <br>

                    <h5>
                      פייסבוק
                    </h5>

                    <!-- Connected Pages List -->
                    <div v-if="connectedFacebookPages.length > 0" class="mb-3">
                      <label class="form-label">דפים מחוברים:</label>
                      <div v-for="page in connectedFacebookPages" :key="page.pageId" class="d-flex align-items-center mb-2">
                        <span class="me-2">{{ page.pageName }}</span>
                        <button class="btn btn-xs btn-danger" style="margin-right: 5px;" @click="disconnectFacebookPage(page.pageId)">
                          נתק
                        </button>
                      </div>
                    </div>

                    <!-- Facebook Pages Selection Modal -->
                    <div v-if="facebookPages.length > 0" class="mb-3">
                      <label class="form-label">בחר דף לחיבור:</label>
                      <div v-for="page in facebookPages" :key="page.id" class="d-flex align-items-center mb-2">
                        <span class="me-2">{{ page.name }}</span>
                        <button class="btn btn-xs btn-primary" style="margin-right: 5px;" @click="connectFacebookPage(page)" :disabled="facebookConnecting">
                          {{ facebookConnecting ? 'מחבר...' : 'חבר' }}
                        </button>
                      </div>
                    </div>

                    <button class="btn btn-primary me-2"
                            @click="getFacebookPages"
                            :disabled="facebookLoading">
                      {{ facebookLoading ? 'טוען...' : 'טען רשימת עמודי פייסבוק' }}
                    </button>
                    <button class="btn btn-sm btn-secondary"
                            @click="debugFacebookToken"
                            :disabled="facebookDebugLoading"
                            style="display: none;">
                      {{ facebookDebugLoading ? 'בודק...' : 'בדיקת הרשאות' }}
                    </button>

                    <div v-if="facebookDebugInfo" class="mt-3 p-3 rounded border" style="direction: ltr; text-align: left; background-color: #fff;">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong style="color: #000;">Token Debug Info:</strong>
                        <button class="btn btn-sm btn-secondary" @click="copyDebugInfo">העתק</button>
                      </div>
                      <pre style="font-size: 12px; max-height: 300px; overflow: auto; color: #000; margin: 0;">{{ JSON.stringify(facebookDebugInfo, null, 2) }}</pre>
                    </div>




                    <br>
                    <br>
                    <br>




                    <h5>
                      חשבונית ירוקה
                    </h5>



                    <div class="row">
                      <div class="col-4">
                        <div class="mb-3">
                          <label class="form-label">
                            מפתח API
                          </label>
                          <input class="form-control"
                                 v-model="$store.state.businessSettings.heshbonitYerukaApiKey">

                        </div>
                      </div>
                      <div class="col-4">
                        <div class="mb-3">
                          <label class="form-label">
                            סוד
                          </label>
                          <input class="form-control"
                                 v-model="$store.state.businessSettings.heshbonitYerukaApiSecret">

                        </div>
                      </div>

                    </div>

                    <br>


                    <label class="form-label">
                      מסמכים להפיק דרך חשבונית ירוקה:
                    </label>
                    <br>

                    <div class="row">




                      <div class="col-md-3 mb-2">

                        <label style="user-select: none;cursor:pointer"
                               @click="$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.hazmana = !$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.hazmana">


                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.taxDocumentsForHeshbonitYeruka.hazmana }">
                            <i class="fa fa-check"></i>
                          </span>

                          הזמנות
                        </label>
                      </div>

                      <div class="col-md-3 mb-2">

                        <label style="user-select: none;cursor:pointer"
                               @click="$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.heshbonitMas = !$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.heshbonitMas">


                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.taxDocumentsForHeshbonitYeruka.heshbonitMas }">
                            <i class="fa fa-check"></i>
                          </span>

                          חשבוניות מס
                        </label>
                      </div>

                      <div class="col-md-3 mb-2">

                        <label style="user-select: none;cursor:pointer"
                               @click="$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.heshbonitMasKabala = !$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.heshbonitMasKabala">


                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.taxDocumentsForHeshbonitYeruka.heshbonitMasKabala }">
                            <i class="fa fa-check"></i>
                          </span>

                          חשבוניות מס קבלה
                        </label>
                      </div>


                      <div class="col-md-3 mb-2">

                        <label style="user-select: none;cursor:pointer"
                               @click="$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.heshbonitZikui = !$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.heshbonitZikui">


                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.taxDocumentsForHeshbonitYeruka.heshbonitZikui }">
                            <i class="fa fa-check"></i>
                          </span>

                          חשבוניות זיכוי
                        </label>
                      </div>

                      <div class="col-md-3 mb-2">

                        <label style="user-select: none;cursor:pointer"
                               @click="$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.kabala = !$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.kabala">


                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.taxDocumentsForHeshbonitYeruka.kabala }">
                            <i class="fa fa-check"></i>
                          </span>

                          קבלות
                        </label>
                      </div>

                      <div class="col-md-3 mb-2">

                        <label style="user-select: none;cursor:pointer"
                               @click="$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.heshbonIska = !$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.heshbonIska">


                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.taxDocumentsForHeshbonitYeruka.heshbonIska }">
                            <i class="fa fa-check"></i>
                          </span>

                          חשבונות עסקה
                        </label>
                      </div>


                      <div class="col-md-3 mb-2">
                        <label style="user-select: none;cursor:pointer"
                               @click="$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.hatsaatMehir = !$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.hatsaatMehir">


                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.taxDocumentsForHeshbonitYeruka.hatsaatMehir }">
                            <i class="fa fa-check"></i>
                          </span>

                          הצעות מחיר
                        </label>
                      </div>


                      <div class="col-md-3 mb-2">
                        <label style="user-select: none;cursor:pointer"
                               @click="$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.teudatMishloah = !$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.teudatMishloah">


                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.taxDocumentsForHeshbonitYeruka.teudatMishloah }">
                            <i class="fa fa-check"></i>
                          </span>

                          תעודות משלוח
                        </label>
                      </div>


                      <div class="col-md-3 mb-2">
                        <label style="user-select: none;cursor:pointer"
                               @click="$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.hazmanatRehesh = !$store.state.businessSettings.taxDocumentsForHeshbonitYeruka.hazmanatRehesh">


                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.taxDocumentsForHeshbonitYeruka.hazmanatRehesh }">
                            <i class="fa fa-check"></i>
                          </span>

                          הזמנות רכש
                        </label>
                      </div>








                    </div>




                    <div class="pull-right">

                      <button class="btn btn-primary"
                              @click="saveHeshbonitYeruka">
                        שמור
                      </button>


                    </div>



                  </div>







                  <!-- BILLING TAB -->

                  <div role="tabpanel"
                       class="tab-pane"
                       :class="{ active: activeTab == 'orginizationSettings_billingTab' }">
                    <div class="row">
                      <div class="col-md-12">

                        <h3>{{ $t('billing') }}</h3>
                        <FormInput label="Billing key"
                                   v-model="userSettings.attrs.billing_api_key"></FormInput>
                        <FormInput label="Billing secret"
                                   v-model="userSettings.attrs.billing_api_secret"></FormInput>
                        <FormInput label="Brand UID"
                                   v-model="userSettings.attrs.billing_api_brand_uuid"></FormInput>
                        <hr>
                        <h3>{{ $t('invoice') }}</h3>
                        <FormInput type="number"
                                   label="מספר עסקה נוכחי"
                                   v-model="userSettings.orderNumbering"
                                   placeholder="0000001"
                                   required></FormInput>

                      </div>
                    </div>

                  </div>







                  <div role="tabpanel"
                       class="tab-pane"
                       :class="{ active: activeTab == 'orginizationSettings_reshutHamisimTab' }">


                    <div class="row">
                      <h5>
                        מספרי רישום
                      </h5>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label">מספר ח.פ</label>
                          <input class="form-control"
                                 type="text"
                                 v-model="$store.state.businessSettings.hetPey"
                                 required />
                          <span class="formErrorText">
                            {{ errors.hetPey }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> מספר עוסק מורשה </label>
                          <input class="form-control"
                                 type="text"
                                 v-model="$store.state.businessSettings.numOsekMurshe"
                                 required />
                          <span class="formErrorText">
                            {{ errors.numOsekMurshe }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> מספר תיק ניכויים </label>
                          <input class="form-control"
                                 type="text"
                                 v-model="$store.state.businessSettings.numTikNihuim"
                                 required />
                          <span class="formErrorText">
                            {{ errors.numTikNihuim }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> מספר חברה ברשם החברות </label>
                          <input class="form-control"
                                 type="text"
                                 v-model="$store.state.businessSettings.numHevraRashamHevrot"
                                 required />
                          <span class="formErrorText">
                            {{ errors.numHevraRashamHevrot }}
                          </span>
                        </div>
                      </div>


                      <div class="col-md-3">
                        <label style="user-select: none;cursor:pointer"
                               @click="$store.state.businessSettings.osekPatur = !$store.state.businessSettings.osekPatur">


                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.osekPatur }">
                            <i class="fa fa-check"></i>
                          </span>

                          עוסק פטור (ללא מע"מ)
                        </label>
                      </div>



                    </div>


                    <br>
                    <br>


                    <div class="row">
                      <h5>
                        חשבונות בנק
                      </h5>


                      <!-- rows + validation shared with the ניהול מהיר modal on the tax-document page
                           (Accounting/BankAccountsQuickEdit) -->
                      <BankAccountsEditor ref="bankAccountsEditor"
                                          :accounts="$store.state.businessSettings.bankAccounts"></BankAccountsEditor>


                    </div>







                    <br>
                    <br>

                    <div class="row">

                      <h5>
                        ספרור מסמכים
                      </h5>



                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> תחילת ספרור לקוחות </label>
                          <input v-model="$store.state.businessSettings.taxDocument_startCount_lakuah
                            "
                                 class="form-control" />
                          <span class="formErrorText">
                            {{ errors.taxDocument_startCount_lakuah }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> תחילת ספרור הזמנות </label>
                          <input v-model="$store.state.businessSettings.taxDocument_startCount_hazmana"
                                 class="form-control" />
                          <span class="formErrorText">
                            {{ errors.taxDocument_startCount_hazmana }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> תחילת ספרור חשבוניות מס </label>
                          <input v-model="$store.state.businessSettings
                            .taxDocument_startCount_heshbonitMas
                            "
                                 class="form-control" />
                          <span class="formErrorText">
                            {{ errors.taxDocument_startCount_heshbonitMas }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label">
                            תחילת סיפרור חשבוניות מס קבלה
                          </label>
                          <input v-model="$store.state.businessSettings
                            .taxDocument_startCount_heshbonitMasKabala
                            "
                                 class="form-control" />
                          <span class="formErrorText">
                            {{ errors.taxDocument_startCount_heshbonitMasKabala }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> תחילת סיפרור חשבוניות זיכוי </label>
                          <input v-model="$store.state.businessSettings
                            .taxDocument_startCount_heshbonitZikui
                            "
                                 class="form-control" />
                          <span class="formErrorText">
                            {{ errors.taxDocument_startCount_heshbonitZikui }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> תחילת סיפרור קבלות </label>
                          <input v-model="$store.state.businessSettings.taxDocument_startCount_kabala
                            "
                                 class="form-control" />
                          <span class="formErrorText">
                            {{ errors.taxDocument_startCount_kabala }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> תחילת סיפרור חשבונות עסקה </label>
                          <input v-model="$store.state.businessSettings.taxDocument_startCount_heshbonIska
                            "
                                 class="form-control" />
                          <span class="formErrorText">
                            {{ errors.taxDocument_startCount_heshbonIska }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> תחילת סיפרור הצעות מחיר </label>
                          <input v-model="$store.state.businessSettings
                            .taxDocument_startCount_hatsaatMehir
                            "
                                 class="form-control" />
                          <span class="formErrorText">
                            {{ errors.taxDocument_startCount_hatsaatMehir }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> תחילת סיפרור תעודות משלוח </label>
                          <input v-model="$store.state.businessSettings
                            .taxDocument_startCount_teudatMishloah
                            "
                                 class="form-control" />
                          <span class="formErrorText">
                            {{ errors.taxDocument_startCount_teudatMishloah }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> תחילת סיפרור הזמנת רכש </label>
                          <input v-model="$store.state.businessSettings
                            .taxDocument_startCount_hazmanatRehesh
                            "
                                 class="form-control" />
                          <span class="formErrorText">
                            {{ errors.taxDocument_startCount_hazmanatRehesh }}
                          </span>
                        </div>
                      </div>


                    </div>


                    <br>
                    <br>

                    <div class="row">

                      <h5>
                        כללי
                      </h5>


                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label">
                            סוג הנהלת חשבונות
                          </label>

                          <Multiselect v-model="selectedTypeOfAccounting"
                                       deselect-label=""
                                       placeholder=""
                                       selectLabel=""
                                       track-by="value"
                                       label="name"
                                       :showNoResults="false"
                                       selectedLabel=""
                                       :options="typesOfAccounting"
                                       :taggable="false">

                              <template slot="noResult">לא נמצאו תוצאות</template>
                              <template slot="noOptions">אין אפשרויות</template>
                          </Multiselect>


                        </div>
                      </div>

                      <div class="col-md-12">
                        <label style="user-select: none;cursor:pointer;font-weight: normal;"
                               @click="$store.state.businessSettings.hatsaatMehirSkipRequiredContactFields = !$store.state.businessSettings.hatsaatMehirSkipRequiredContactFields">
                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: !$store.state.businessSettings.hatsaatMehirSkipRequiredContactFields }">
                            <i class="fa fa-check"></i>
                          </span>
                          הפקת הצעת מחיר מחייבת פרטי איש קשר מלאים (שם פרטי ושם משפחה) כמו בשאר המסמכים החשבונאיים
                        </label>
                        <br>
                        <small class="text-muted">
                          כשהאפשרות כבויה, ניתן להפיק הצעת מחיר גם כשפרטי איש הקשר חסרים.
                        </small>
                      </div>

                      <div class="col-md-12" style="margin-top:15px;">
                        <label style="user-select: none;cursor:pointer;font-weight: normal;"
                               @click="$store.state.businessSettings.hatsaatMehirSignatureByDefault = !$store.state.businessSettings.hatsaatMehirSignatureByDefault">
                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.hatsaatMehirSignatureByDefault }">
                            <i class="fa fa-check"></i>
                          </span>
                          חתימת לקוח על הצעת מחיר כברירת מחדל
                        </label>
                        <br>
                        <small class="text-muted">
                          קובע האם האפשרות "חתימת לקוח" ביצירת הצעת מחיר תהיה מסומנת מראש. ניתן לשנות את הבחירה בכל הצעת מחיר בנפרד.
                        </small>
                      </div>

                      <div class="col-md-12" style="margin-top:15px;">
                        <label style="user-select: none;cursor:pointer;font-weight: normal;"
                               @click="$store.state.businessSettings.alwaysRequireTeudatZehut = !$store.state.businessSettings.alwaysRequireTeudatZehut">
                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.alwaysRequireTeudatZehut }">
                            <i class="fa fa-check"></i>
                          </span>
                          דרוש תעודת זהות של הלקוח בכל מסמך חשבונאי, גם מתחת ל-5,000 ₪
                        </label>
                        <br>
                        <small class="text-muted">
                          כשהאפשרות כבויה, ניתן להפיק מסמכים בסכום של עד 5,000 ₪ גם ללא תעודת זהות של הלקוח. במסמכים בסכום של 5,000 ₪ ומעלה תעודת הזהות תמיד חובה.
                        </small>
                      </div>

                    </div>

                    <br>

                    <div class="row">

                      <h5>
                        חשבוניות ישראל
                      </h5>


                      <div class="col-md-12">
                        <div class="mb-3">

                          לצורך הפקת חשבוניות ישראל יש לבצע הרשאה מול רשות המסים.

                          <br>
                          <br>

                          <!-- connected or not, since when, until when (a consent holds 90 days), the
                               last allocation number, a live check - and the connect button -->
                          <TaxAuthorityConnectionStatus v-if="activeTab == 'orginizationSettings_reshutHamisimTab'"></TaxAuthorityConnectionStatus>

                          <template v-if="false">
                            <button class="btn btn-primary"
                                    style="margin-right:8px"
                                    @click="openRetroAllocationModal()">
                              בקש מספרי הקצאה לכל החשבוניות הישנות
                            </button>
                            <br>
                            <small class="text-muted">
                              שליחת בקשה לרשות המסים עבור חשבוניות ישנות (חשבונית מס / חשבונית מס קבלה) שלא קיבלו מספר הקצאה.
                            </small>
                          </template>

                          <hr>

                          <label>בקש מספר הקצאה רק מחשבוניות שסכומן (כולל מע״מ) לפחות:</label>
                          <div style="display:flex;align-items:center;gap:6px;max-width:260px;">
                            <input type="number"
                                   min="0"
                                   step="1"
                                   class="form-control"
                                   placeholder="5000"
                                   v-model.number="$store.state.businessSettings.heshboniotIsraelMinAmount">
                            <span>₪</span>
                          </div>
                          <small class="text-muted">
                            מתחת לסכום זה לא תישלח בקשה לרשות המסים. כשהשדה ריק חלה ברירת המחדל: 5,000 ₪. לבקשת מספר הקצאה עבור כל החשבוניות — הזינו 0.
                          </small>

                        </div>
                      </div>

                    </div>

                    <button @click="saveMisimTab()"
                            class="btn btn-primary pull-right">{{ $t("save") }}</button>





                  </div>

                  <!-- GENERAL TAB -->

                  <div role="tabpanel"
                       class="tab-pane"
                       :class="{ active: activeTab == 'orginizationSettings_generalTab' }">
                    <div class="row">
                      <div>


                        <img :src="$store.state.logoImageUrl"
                             onerror="this.src='https://www.mit4mit.co.il/img/biz_placeHolder.png'"
                             style="max-width:80px;max-height:80px;border-radius:6px;">


                        <span style="color: #ab8ce4; cursor: pointer"
                              @click="$refs.uploadLogoFileInput.click()">
                          עדכן לוגו לעסק
                        </span>


                        &nbsp;
                        &nbsp;



                        <img style="max-width:80px;max-height:80px;border-radius:6px;"
                             onerror="this.src='https://www.mit4mit.co.il/img/biz_placeHolder.png'"
                             :src="`data:${$store.state.businessSettings.signature64mimetype};base64, ${$store.state.businessSettings.signature64}`">


                        <span style="color: #ab8ce4; cursor: pointer"
                              @click="$refs.uploadSignatureFileInput.click()">
                          העלה חתימה סרוקה
                        </span>


                        <br />
                        <br />

                        <input ref="uploadLogoFileInput"
                               type="file"
                               style="display: none"
                               @change="uploadLogo" />
                        <br />

                        <input ref="uploadSignatureFileInput"
                               type="file"
                               accept="image/png, image/jpeg"
                               style="display: none"
                               @change="uploadSignature" />

                        <br />
                        <br />
                      </div>


                      <h5>כללי</h5>

                      <div class="col-md-4">
                        <div class="mb-3">
                          <label class="form-label">שם העסק</label>
                          <input class="form-control"
                                 type="text"
                                 v-model="$store.state.businessSettings.bizName" />
                          <span class="formErrorText">
                            {{ errors.bizName }}
                          </span>





                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="mb-3">
                          <label class="form-label">טלפון</label>
                          <input type="text"
                                 class="form-control"
                                 v-model="$store.state.businessSettings.phone" />
                          <span class="formErrorText">
                            {{ errors.phone }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="mb-3">
                          <label class="form-label">

                            תיבת דואר

                            planup.co.il@
                          </label>
                          <input type="text"
                                 class="form-control"
                                 v-model="$store.state.businessSettings.nameForPlanupEmail" />
                          <span class="formErrorText">
                            {{ errors.nameForPlanupEmail }}
                          </span>
                        </div>
                      </div>




                      <!-- <label style="user-select: none; cursor: pointer"
                             @click="
                               $store.state.businessSettings.hasSnifim = !$store.state
                                 .businessSettings.hasSnifim
                               ">
                        <span style="position: relative; top: 1px"
                              class="planup-checkbox planup-checkbox-purple"
                              :class="{
                                checked: $store.state.businessSettings.hasSnifim,
                              }">
                          <i class="fa fa-check"></i>
                        </span>

                        לעסק יש סניפים
                      </label> -->

                      <br>
                      <br>
                    </div>

                    <br>

                    <!-- אפליקציה במסך הבית - about the device the settings are open on, saved on it at
                         once (HomeScreenSettings.vue); the same offer as the popup after login -->
                    <div class="row"
                         id="homeScreenSettings">
                      <h5>
                        אפליקציה במסך הבית
                      </h5>
                      <div class="col-md-9">
                        <HomeScreenSettings></HomeScreenSettings>
                      </div>
                    </div>

                    <br>

                    <!-- רקע המערכת - a very faint drawing behind the cards on every page, off by default; a tile
                         saves at once for the whole account (PageBackgroundSettings.vue) -->
                    <div class="row"
                         id="pageBackgroundSettings">
                      <h5>
                        רקע המערכת
                      </h5>
                      <div class="col-md-9">
                        <PageBackgroundSettings></PageBackgroundSettings>
                      </div>
                    </div>

                    <br>

                    <div class="row">
                      <h5>
                        כתובת
                      </h5>


                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> רחוב </label>
                          <input class="form-control"
                                 type="text"
                                 v-model="$store.state.businessSettings.address_street" />
                          <span class="formErrorText">
                            {{ errors.address_street }}
                          </span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> מספר בית </label>
                          <input v-model="$store.state.businessSettings.address_number"
                                 class="form-control" />
                          <span class="formErrorText">
                            {{ errors.address_number }}
                          </span>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> עיר</label>
                          <input v-model="$store.state.businessSettings.address_city"
                                 class="form-control" />
                          <span class="formErrorText">
                            {{ errors.address_city }}
                          </span>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label"> מיקוד</label>
                          <input v-model="$store.state.businessSettings.address_mikud"
                                 class="form-control" />
                          <span class="formErrorText">
                            {{ errors.address_mikud }}
                          </span>
                        </div>
                      </div>
                      <br>
                      <br>
                    </div>



                    <br>
                    <div class="row">

                      <h5>
                        שעות פעילות לתצוגה ביומן
                      </h5>

                      <div class="col-md-3">
                        <div>
                          <label class="form-label">
                            תחילת יום עבודה
                          </label>

                          <WheelTimePicker v-model="$store.state.businessSettings.workDayStart"
                                           :minuteStep="60"
                                           :clearable="false"></WheelTimePicker>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div>
                          <label class="form-label">
                            סיום יום עבודה
                          </label>

                          <WheelTimePicker v-model="$store.state.businessSettings.workDayEnd"
                                           :minuteStep="60"
                                           :clearable="false"></WheelTimePicker>
                        </div>
                      </div>



                      <div class="col-md-3">
                        <div>
                          <label class="form-label">
                            שעה ברירת מחדל לתחילת אירועים
                          </label>

                          <WheelTimePicker v-model="$store.state.businessSettings.defaultEventTime"></WheelTimePicker>
                        </div>
                      </div>





                    </div>

                    <br>

                    <!-- מקורות לידים - list editor, saves immediately (LeadSourcesSettings.vue) -->
                    <div class="row">
                      <h5>
                        מקורות לידים
                      </h5>
                      <div class="col-md-9">
                        <LeadSourcesSettings></LeadSourcesSettings>
                      </div>
                    </div>

                    <br>

                    <!-- מלאי והשכרות (inventory businesses only): the deal milestone at which a catalog
                         item picked into a deal becomes שמורה / נמכר — business_setting.inventoryReserveOn,
                         read by InventoryService.dealReachedReserveMilestone -->
                    <div class="row" v-if="hasInventoryAccess" id="inventoryReserveOnSettings">
                      <h5>
                        מלאי והשכרות
                      </h5>

                      <div class="col-md-7">
                        <label class="form-label">מתי פריט מהקטלוג נשמר ללקוח (שמורה / נמכר)?</label>
                        <p style="font-size: 12px; color: #777; margin-bottom: 10px;">
                          עד לשלב שנבחר הפריט רק נרשם כ"הוצעה בהצעת מחיר" ליד העותק ואינו חוסם אותו ללקוחות אחרים;
                          כשהעסקה מגיעה לשלב הזה הוא משוריין (או מסומן כנמכר) אוטומטית. "שריון עכשיו" בכרטיס הלקוח עובד תמיד, בלי קשר להגדרה.
                        </p>
                        <div>
                          <label v-for="opt in inventoryReserveOptions"
                                 :key="opt.value"
                                 class="planup-radio-wrapper"
                                 style="display:block;margin-bottom:6px;"
                                 :data-reserve-on="opt.value"
                                 @click="setInventoryReserveOn(opt.value)">
                            <span class="planup-radio"
                                  :class="{ checked: inventoryReserveOn == opt.value }">
                            </span>
                            {{ opt.label }}
                            <small style="color:#888;">— {{ opt.hint }}</small>
                          </label>
                        </div>
                      </div>
                    </div>

                    <br>

                    <div class="row">

                      <h5>
                        שונות
                      </h5>

                      <div class="col-md-3">
                        <label style="user-select: none;cursor:pointer"
                               class="mb-2"
                               @click="$store.state.businessSettings.validateLeadSource = !$store.state.businessSettings.validateLeadSource">


                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.validateLeadSource }">
                            <i class="fa fa-check"></i>
                          </span>

                          חובה להזין מקור ליד
                        </label>

                        <br>
                        <label style="user-select: none;cursor:pointer"
                               class="mb-2"
                               @click="$store.state.businessSettings.showSapakimNosafimInHazmana = !$store.state.businessSettings.showSapakimNosafimInHazmana">

                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.showSapakimNosafimInHazmana }">
                            <i class="fa fa-check"></i>
                          </span>

                          הצג ספקים נוספים בהזמנה
                        </label>

                        <br>
                        <label style="user-select: none;cursor:pointer"
                               class="mb-2"
                               @click="$store.state.businessSettings.sendContactUpdateNotifications = !$store.state.businessSettings.sendContactUpdateNotifications">

                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.sendContactUpdateNotifications !== false }">
                            <i class="fa fa-check"></i>
                          </span>

                          שלח התראות בעדכון פרטי איש קשר
                        </label>

                        <br>
                        <label style="user-select: none;cursor:pointer"
                               class="mb-2"
                               @click="$store.state.businessSettings.sendSmsOnNewLead = !$store.state.businessSettings.sendSmsOnNewLead">

                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.sendSmsOnNewLead !== false }">
                            <i class="fa fa-check"></i>
                          </span>

                          שלח SMS בפנייה חדשה
                        </label>

                        <br>
                        <br>

                        <div>
                          <label class="form-label">מיקום לוגו במסמכים</label>
                          <div>
                            <label class="planup-radio-wrapper"
                                   style="margin-left: 20px;"
                                   @click="$store.state.businessSettings.logoPosition = 'side'">
                              <span class="planup-radio"
                                    :class="{ checked: !$store.state.businessSettings.logoPosition || $store.state.businessSettings.logoPosition == 'side' }">
                              </span>
                              בצד
                            </label>

                            <label class="planup-radio-wrapper"
                                   @click="$store.state.businessSettings.logoPosition = 'middle'">
                              <span class="planup-radio"
                                    :class="{ checked: $store.state.businessSettings.logoPosition == 'middle' }">
                              </span>
                              באמצע
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-5">
                        <label class="form-label">שדות בטופס עדכון איש קשר</label>
                        <p style="font-size: 12px; color: #777; margin-bottom: 10px;">בחר אילו שדות יוצגו בטופס עדכון פרטי איש קשר</p>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <label style="user-select: none;cursor:pointer"
                                   @click="toggleContactField('lastName')">
                              <span style="position:relative;top:1px;"
                                    class="planup-checkbox planup-checkbox-purple"
                                    :class="{ checked: isContactFieldVisible('lastName') }">
                                <i class="fa fa-check"></i>
                              </span>
                              שם משפחה
                            </label>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label style="user-select: none;cursor:pointer"
                                   @click="toggleContactField('email')">
                              <span style="position:relative;top:1px;"
                                    class="planup-checkbox planup-checkbox-purple"
                                    :class="{ checked: isContactFieldVisible('email') }">
                                <i class="fa fa-check"></i>
                              </span>
                              מייל
                            </label>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label style="user-select: none;cursor:pointer"
                                   @click="toggleContactField('teudatZehut')">
                              <span style="position:relative;top:1px;"
                                    class="planup-checkbox planup-checkbox-purple"
                                    :class="{ checked: isContactFieldVisible('teudatZehut') }">
                                <i class="fa fa-check"></i>
                              </span>
                              תעודת זהות
                            </label>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label style="user-select: none;cursor:pointer"
                                   @click="toggleContactField('address_street')">
                              <span style="position:relative;top:1px;"
                                    class="planup-checkbox planup-checkbox-purple"
                                    :class="{ checked: isContactFieldVisible('address_street') }">
                                <i class="fa fa-check"></i>
                              </span>
                              רחוב
                            </label>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label style="user-select: none;cursor:pointer"
                                   @click="toggleContactField('address_number')">
                              <span style="position:relative;top:1px;"
                                    class="planup-checkbox planup-checkbox-purple"
                                    :class="{ checked: isContactFieldVisible('address_number') }">
                                <i class="fa fa-check"></i>
                              </span>
                              מספר בית
                            </label>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label style="user-select: none;cursor:pointer"
                                   @click="toggleContactField('address_city')">
                              <span style="position:relative;top:1px;"
                                    class="planup-checkbox planup-checkbox-purple"
                                    :class="{ checked: isContactFieldVisible('address_city') }">
                                <i class="fa fa-check"></i>
                              </span>
                              עיר
                            </label>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label style="user-select: none;cursor:pointer"
                                   @click="toggleContactField('address_mikud')">
                              <span style="position:relative;top:1px;"
                                    class="planup-checkbox planup-checkbox-purple"
                                    :class="{ checked: isContactFieldVisible('address_mikud') }">
                                <i class="fa fa-check"></i>
                              </span>
                              מיקוד
                            </label>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label style="user-select: none;cursor:pointer"
                                   @click="toggleContactField('comment')">
                              <span style="position:relative;top:1px;"
                                    class="planup-checkbox planup-checkbox-purple"
                                    :class="{ checked: isContactFieldVisible('comment') }">
                                <i class="fa fa-check"></i>
                              </span>
                              הערה אישית
                            </label>
                          </div>
                        </div>
                      </div>


                    </div>

                    <br>

                    <div class="row">
                      <div class="col-md-12">
                        <h6 style="color:#777;margin-bottom:15px;">ייבוא לקוחות מקובץ CSV</h6>
                        <button class="btn btn-outline-primary btn-sm"
                                @click="showCSVUploadModal(false)">
                          העלה קובץ CSV
                        </button>
                        <!-- &nbsp;
                        <button class="btn btn-outline-secondary btn-sm"
                                @click="showCSVUploadModal(true)">
                          <i class="fa fa-dollar-sign"></i>
                          עדכון מחירים CSV
                        </button> -->

                        <input type="file"
                               style="display:none"
                               id="uploadCSVfileInput"
                               ref="uploadCSVfileInputOld"
                               @change="uploadCSV()">
                      </div>
                    </div>

                    <br>

                    <div class="row">
                      <div class="col-md-12">
                        <label style="user-select: none;cursor:pointer;font-weight: normal;"
                               @click="$store.state.businessSettings.showAllContactsInTaxDocumentByDefault = !$store.state.businessSettings.showAllContactsInTaxDocumentByDefault">
                          <span style="position:relative;top:1px;"
                                class="planup-checkbox planup-checkbox-purple"
                                :class="{ checked: $store.state.businessSettings.showAllContactsInTaxDocumentByDefault }">
                            <i class="fa fa-check"></i>
                          </span>
                          הצג את כל אנשי הקשר במסמך חשבונאי כברירת מחדל
                        </label>
                      </div>
                    </div>

                    <br>

                    <!-- צבעי לוח שנה - events by status, meetings by type, tasks (CalendarColorsSettings.vue);
                         saved below with the rest of the tab (saveGeneralTab) -->
                    <div class="row"
                         id="calendarColorsSettings">
                      <h5>
                        צבעי לוח שנה
                      </h5>
                      <div class="col-md-12">
                        <CalendarColorsSettings></CalendarColorsSettings>
                      </div>
                    </div>

                    <br>
                    <br>
                    <button @click="saveGeneralTab()"
                            class="btn btn-primary pull-right">{{ $t("save") }}</button>




                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- Manual search_result reconciliation. Deliberately small and dull: it has to be
         findable when support asks for it, not tempting to click out of curiosity. -->
    <div class="dangerZone">
      <span class="dangerZoneTrigger"
            @click="fixSearchResults()">
        <i class="fa-solid fa-skull-crossbones"></i>
        הנשמה למערכת
      </span>
    </div>



    <!-- the "ברוכים הבאים" popup (ח.פ, נתוני חשבונאות, ספרור מסמכים) that opened here on every visit while
         the tax details were missing moved to Onboarding/TaxDetailsPrompt.vue (5/11/2026): it comes up once a
         session, on the first finance screen, and its main button brings the user to the רשות המיסים tab -->



    <Modal ref="csvFormatModal"
           :hideFooter="true"
           :title="justPriceChangeCSV ? 'עדכון מחירים מקובץ CSV' : 'ייבוא לקוחות מקובץ CSV'">
      <template v-slot:body>
        <div v-if="!justPriceChangeCSV">
          <h5>פורמט הקובץ לייבוא לקוחות</h5>
          <p>הקובץ צריך להכיל את העמודות הבאות (בדיוק לפי הסדר):</p>
          <ol>
            <li><strong>תאריך:</strong> תאריך האירוע בפורמט DD/MM/YYYY (לדוגמה: 15/06/2024)</li>
            <li><strong>סטטוס:</strong> סטטוס האירוע ("סגור" או ריק עבור פניה בטיפול)</li>
            <li><strong>מקום אירוע:</strong> שם מקום האירוע</li>
            <li><strong>שם:</strong> שם הלקוח (ניתן לכתוב שמות של שני בני זוג מופרדים ב-"ו")</li>
            <li><strong>טלפון:</strong> מספר טלפון (10 ספרות)</li>
            <li><strong>צוות:</strong> שמות אנשי צוות (ניתן לכתוב מספר שמות מופרדים ב-"ו")</li>
            <li><strong>מחיר:</strong> מחיר האירוע (מספר)</li>
            <li><strong>תאריך חתימה:</strong> תאריך חתימת ההזמנה בפורמט DD/MM/YYYY</li>
          </ol>
          <br>
          <p style="color:#777;font-size:14px">
            <strong>שימו לב:</strong> השורה הראשונה בקובץ צריכה להכיל כותרות ותידלג אוטומטית.
          </p>
        </div>

        <div v-else>
          <h5>פורמט הקובץ לעדכון מחירים</h5>
          <p>הקובץ צריך להכיל את אותן עמודות כמו בייבוא רגיל, אך המערכת תחפש לקוחות קיימים לפי מספר טלפון ותעדכן את
            המחיר שלהם.</p>
          <ol>
            <li><strong>תאריך:</strong> תאריך האירוע (לא חובה לעדכון מחיר)</li>
            <li><strong>סטטוס:</strong> סטטוס האירוע (לא חובה לעדכון מחיר)</li>
            <li><strong>מקום אירוע:</strong> מקום האירוע (לא חובה לעדכון מחיר)</li>
            <li><strong>שם:</strong> שם הלקוח (לא חובה לעדכון מחיר)</li>
            <li><strong>טלפון:</strong> <strong style="color:#ff5370">חובה!</strong> מספר טלפון לזיהוי הלקוח</li>
            <li><strong>צוות:</strong> אנשי צוות (לא חובה לעדכון מחיר)</li>
            <li><strong>מחיר:</strong> <strong style="color:#ff5370">חובה!</strong> המחיר החדש לעדכון</li>
            <li><strong>תאריך חתימה:</strong> תאריך חתימה (לא חובה לעדכון מחיר)</li>
          </ol>
          <br>
          <p style="color:#ff5370;font-size:14px">
            <strong>אזהרה:</strong> פעולה זו תעדכן מחירים של אירועים קיימים. ודאו שהקובץ נכון לפני ההעלאה.
          </p>
        </div>

        <br>
        <div>
          <button class="btn btn-primary pull-right"
                  @click="$refs.uploadCSVfileInput.click()">
            בחר קובץ והעלה
          </button>
          <input type="file"
                 style="display:none"
                 accept=".csv"
                 ref="uploadCSVfileInput"
                 @change="uploadCSV()">
        </div>
      </template>

    </Modal>


    <!-- Retroactive allocation-number request: choose "do all" (default) or select manually -->
    <Modal ref="retroAllocationModal"
           :large="true"
           title="בקשת מספרי הקצאה לחשבוניות ישנות">
      <template v-slot:body>
        <div v-if="retroInvoices.length">
          <p class="text-muted" style="font-size:14px">
            נמצאו {{ retroInvoices.length }} חשבוניות ללא מספר הקצאה. כל החשבוניות מסומנות כברירת מחדל — ניתן לבטל סימון
            עבור חשבוניות שכבר טופלו, ולשלוח בקשה רק עבור המסומנות.
          </p>

          <div class="d-flex justify-content-between align-items-center mb-2">
            <label style="cursor:pointer;margin:0;font-weight:600">
              <input type="checkbox"
                     :checked="isAllRetroSelected()"
                     @change="toggleSelectAllRetro($event.target.checked)">
              בחר הכל
            </label>
            <span class="text-muted" style="font-size:14px">
              נבחרו {{ retroSelectedCount() }} מתוך {{ retroInvoices.length }}
            </span>
          </div>

          <div style="max-height:50vh;overflow-y:auto">
            <table class="table table-sm table-hover" style="margin:0">
              <thead>
                <tr>
                  <th style="width:40px"></th>
                  <th>מספר</th>
                  <th>סוג</th>
                  <th>תאריך</th>
                  <th>לקוח</th>
                  <th>סכום</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="inv in retroInvoices"
                    :key="inv.id"
                    style="cursor:pointer"
                    @click="inv.selected = !inv.selected">
                  <td>
                    <input type="checkbox" v-model="inv.selected" @click.stop>
                  </td>
                  <td>{{ inv.taxDocumentNumber }}</td>
                  <td>{{ docTypeLabel(inv.type) }}</td>
                  <td>{{ formatInvoiceDate(inv.creationDate) }}</td>
                  <td>
                    {{ $globals.taxDocumentCustomerName(inv) }}
                    <span v-if="inv.hasError"
                          class="badge"
                          style="background:#ffe3ec;color:#ff5370;margin-right:4px">
                      שגיאה קודמת
                    </span>
                  </td>
                  <td>{{ formatAmount(inv.totalPriceAfterVat) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-else>
          <p>אין חשבוניות הממתינות למספר הקצאה.</p>
        </div>
      </template>

      <template v-slot:buttons>
        <button class="btn btn-secondary" data-bs-dismiss="modal">ביטול</button>
        <button class="btn btn-primary"
                :disabled="!retroSelectedCount()"
                @click="sendRetroSelected()">
          שלח בקשות ({{ retroSelectedCount() }})
        </button>
      </template>

    </Modal>


  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { apiPost } from "../../core/http/axios_api_v2";
import { getMissingAllocation, requestAllocationForIds } from "../../core/heshboniotIsrael";
import GoogleSettings from "./GoogleSettings.vue";
import WheelTimePicker from "../Common/WheelTimePicker.vue";
import WhatsappTab from "./Tabs/WhatsappTab.vue";
import BankAccountsEditor from "../Common/BankAccountsEditor.vue";
import LeadSourcesSettings from "./LeadSourcesSettings.vue";
import CalendarColorsSettings from "./CalendarColorsSettings.vue";
import HomeScreenSettings from "./HomeScreenSettings.vue";
import PageBackgroundSettings from "./PageBackgroundSettings.vue";
import hasPermission from "../../core/acl/acl";
import { RESERVE_ON_OPTIONS, RESERVE_ON_DEFAULT } from "../Inventory/inv-utils";
import CustomerTabsBar from "../Customers/CustomerTabsBar.vue";
import TaxAuthorityConnectionStatus from "./TaxAuthorityConnectionStatus.vue";

export default {
  name: "Settings",

  data() {

    let workDayHourList = [];


    for (let i = 0; i < 24; i++) {
      workDayHourList.push(`${i}:00`);
    }


    return {
      heshboniotIsraelClientId: '58ccdc52d0258281ae95f83214028ee5',
      // heshboniotIsraelRedirectUri: 'https://planup.co.il/heshboniot-israel',
      heshboniotIsraelRedirectUri: 'https://planup.co.il/apiv2/heshboniotisrael/oAuthRedirect',

      // Retroactive allocation-number request modal (each item gets a `selected` flag)
      retroInvoices: [],

      selectedTypeOfAccounting: null,
      typesOfAccounting: [
        { value: 0, name: "לא רלוונטי" },
        { value: 1, name: "חד צידית" },
        { value: 2, name: "כפולה" }
      ],

      workDayHourList,
      errors: {},
      justPriceChangeCSV: false,
      facebookPages: [],
      connectedFacebookPages: [],
      facebookLoading: false,
      facebookConnecting: false,
      facebookDebugLoading: false,
      facebookDebugInfo: null,
      tabs: [
        "orginizationSettings_generalTab",
        "orginizationSettings_reshutHamisimTab",
        // "orginizationSettings_billingTab",
        "orginizationSettings_googleTab",
        "orginizationSettings_whatsappTab",
      ],
      activeTab: "orginizationSettings_generalTab",
      googleUserData: null,
      userSettings: { attrs: {} },
    };
  },
  computed: {

    // the מלאי והשכרות block is for catalog businesses only (per-user 'inventory' grant)
    hasInventoryAccess() {
      return hasPermission(this.$store.getters.getUser, 'inventory');
    },
    inventoryReserveOptions() {
      return RESERVE_ON_OPTIONS;
    },
    inventoryReserveOn() {
      var value = this.$store.state.businessSettings.inventoryReserveOn;
      return RESERVE_ON_OPTIONS.some(function (o) { return o.value == value; }) ? value : RESERVE_ON_DEFAULT;
    },

    //the whatsapp tab goes away when the root admin switched the module off for this account
    visibleTabs() {
      var disabled = this.$store.state.disabledFeatures || [];
      return this.tabs.filter(function (tab) {
        return !(tab == 'orginizationSettings_whatsappTab' && disabled.indexOf('whatsapp') > -1);
      });
    },

  },

  methods: {

    // $set: the key is absent from the store object on accounts whose row predates the column
    setInventoryReserveOn(value) {
      this.$set(this.$store.state.businessSettings, 'inventoryReserveOn', value);
    },

    isContactFieldVisible(field) {
      var visibility = this.$store.state.businessSettings.contactFormFieldsVisibility;
      if (!visibility) return true;
      return visibility[field] !== false;
    },

    toggleContactField(field) {
      if (!this.$store.state.businessSettings.contactFormFieldsVisibility) {
        this.$set(this.$store.state.businessSettings, 'contactFormFieldsVisibility', {});
      }
      var currentValue = this.isContactFieldVisible(field);
      this.$set(this.$store.state.businessSettings.contactFormFieldsVisibility, field, !currentValue);
    },

    debugFacebookToken() {
      var self = this;
      self.facebookDebugLoading = true;
      self.facebookDebugInfo = null;

      window.FB.login(function (response) {
        if (response.status !== 'connected' || !response.authResponse || !response.authResponse.accessToken) {
          alert('שגיאה בהתחברות לפייסבוק');
          self.facebookDebugLoading = false;
          return;
        }

        axios.post('facebook/debug-token', { token: response.authResponse.accessToken })
          .then(function (res) {
            self.facebookDebugLoading = false;
            self.facebookDebugInfo = res.data;
            console.log('Facebook debug info:', res.data);
          })
          .catch(function (error) {
            self.facebookDebugLoading = false;
            console.error('Error debugging Facebook token:', error);
            alert('שגיאה בבדיקת הטוקן');
          });

      }, { scope: 'pages_show_list,email,pages_read_engagement,pages_manage_metadata,leads_retrieval' });
    },

    copyDebugInfo() {
      var text = JSON.stringify(this.facebookDebugInfo, null, 2);
      navigator.clipboard.writeText(text).then(function () {
        alert('הועתק!');
      }).catch(function (err) {
        console.error('Failed to copy:', err);
        alert('שגיאה בהעתקה');
      });
    },

    getFacebookPages() {
      var self = this;
      self.facebookLoading = true;
      self.facebookPages = [];

      window.FB.login(function (response) {

        if (response.status !== 'connected' || !response.authResponse || !response.authResponse.accessToken) {
          alert('שגיאה בהתחברות לפייסבוק');
          self.facebookLoading = false;
          return;
        }

        axios.post('facebook/pages', { token: response.authResponse.accessToken })
          .then(function (res) {
            self.facebookLoading = false;
            if (res.data && res.data.length > 0) {
              self.facebookPages = res.data;
            } else {
              alert('לא נמצאו דפים בחשבון הפייסבוק');
            }
          })
          .catch(function (error) {
            self.facebookLoading = false;
            console.error('Error fetching Facebook pages:', error);
            alert('שגיאה בטעינת דפי פייסבוק');
          });

      }, { scope: 'pages_show_list,email,pages_read_engagement,pages_manage_metadata,leads_retrieval' });

    },

    connectFacebookPage(page) {
      var self = this;
      self.facebookConnecting = true;

      axios.post('facebook/connect-page', {
        pageId: page.id,
        pageName: page.name,
        pageAccessToken: page.access_token
      })
        .then(function (res) {
          self.facebookConnecting = false;
          if (res.data && res.data.success) {
            self.connectedFacebookPages.push({
              pageId: page.id,
              pageName: page.name
            });
            // Remove from available pages
            self.facebookPages = self.facebookPages.filter(function (p) {
              return p.id !== page.id;
            });
            self.$swal({
              type: 'success',
              title: 'הדף חובר בהצלחה',
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            });
          } else {
            alert('שגיאה בחיבור הדף: ' + (res.data.error || 'שגיאה לא ידועה'));
          }
        })
        .catch(function (error) {
          self.facebookConnecting = false;
          console.error('Error connecting Facebook page:', error);
          alert('שגיאה בחיבור הדף');
        });
    },

    disconnectFacebookPage(pageId) {
      var self = this;

      if (!confirm('האם אתה בטוח שברצונך לנתק את הדף?')) {
        return;
      }

      axios.delete('facebook/disconnect-page/' + pageId)
        .then(function (res) {
          if (res.data && res.data.success) {
            self.connectedFacebookPages = self.connectedFacebookPages.filter(function (p) {
              return p.pageId !== pageId;
            });
            self.$swal({
              type: 'success',
              title: 'הדף נותק בהצלחה',
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            });
          }
        })
        .catch(function (error) {
          console.error('Error disconnecting Facebook page:', error);
          alert('שגיאה בניתוק הדף');
        });
    },

    loadConnectedFacebookPages() {
      var self = this;

      axios.get('facebook/connected-pages')
        .then(function (res) {
          if (res.data && res.data.success && res.data.pages) {
            self.connectedFacebookPages = res.data.pages;
          }
        })
        .catch(function (error) {
          console.error('Error loading connected Facebook pages:', error);
        });
    },

    saveHeshbonitYeruka() {

      let saveData = {
        heshbonitYerukaApiKey: this.$store.state.businessSettings.heshbonitYerukaApiKey,
        heshbonitYerukaApiSecret: this.$store.state.businessSettings.heshbonitYerukaApiSecret,
        taxDocumentsForHeshbonitYeruka: this.$store.state.businessSettings.taxDocumentsForHeshbonitYeruka
      }

      apiPost('business-settings', saveData);
    },





    validateGeneralTab() {

      let errors = {};


      if (!this.$store.state.businessSettings.bizName)
        errors.bizName = "שדה חובה";


      if (!this.$store.state.businessSettings.phone || !this.$store.state.businessSettings.phone.toString().match(/^\d{9,10}$/) || this.$store.state.businessSettings.phone[0] != '0')
        errors.phone = "מספר טלפון לא תקין";


      // if (!this.$store.state.businessSettings.address_street)
      //   errors.address_street = "שדה חובה";

      // if (!this.$store.state.businessSettings.address_number)
      //   errors.address_number = "שדה חובה";

      // if (!this.$store.state.businessSettings.address_city)
      //   errors.address_city = "שדה חובה";

      if (this.$store.state.businessSettings.address_mikud && !this.$store.state.businessSettings.address_mikud.toString().match(/^\d{7}$/))
        errors.address_mikud = "נא להזין מיקוד תקין";


      if (!this.$store.state.businessSettings?.nameForPlanupEmail?.length) {

        errors.nameForPlanupEmail = "שדה חובה";

      } else if (!this.$store.state.businessSettings.nameForPlanupEmail.match(/^[a-z0-9]+$/i)) {

        errors.nameForPlanupEmail = 'אותיות באנגלית ומספרים בלבד';

      } else if (['office', 'info', 'admin', 'support'].includes(this.$store.state.businessSettings.nameForPlanupEmail)) {

        errors.nameForPlanupEmail = 'לא ניתן לבחור בשם בזה';

      }

      this.$set(this, "errors", errors);

      //this checks if there is at least one field with an error
      let valid = !Object.values(this.errors).some(value => value);

      if (!valid)
        planup.$globals.notifyFormError();

      return valid;
    },

    saveGeneralTab() {


      if (!this.validateGeneralTab())
        return;

      let saveData = {
        bizName: this.$store.state.businessSettings.bizName,
        phone: this.$store.state.businessSettings.phone,
        hasSnifim: this.$store.state.businessSettings.hasSnifim,
        address_street: this.$store.state.businessSettings.address_street,
        address_number: this.$store.state.businessSettings.address_number,
        address_city: this.$store.state.businessSettings.address_city,
        address_mikud: this.$store.state.businessSettings.address_mikud,
        nameForPlanupEmail: this.$store.state.businessSettings.nameForPlanupEmail,
        workDayStart: this.$store.state.businessSettings.workDayStart,
        workDayEnd: this.$store.state.businessSettings.workDayEnd,
        defaultEventTime: this.$store.state.businessSettings.defaultEventTime,
        validateLeadSource: this.$store.state.businessSettings.validateLeadSource,
        showSapakimNosafimInHazmana: this.$store.state.businessSettings.showSapakimNosafimInHazmana,
        logoPosition: this.$store.state.businessSettings.logoPosition,
        calendarEventColor: this.$store.state.businessSettings.calendarEventColor,
        calendarTaskColor: this.$store.state.businessSettings.calendarTaskColor,
        calendarMeetingColor: this.$store.state.businessSettings.calendarMeetingColor,
        calendarColors: this.$store.state.businessSettings.calendarColors || null,
        showAllContactsInTaxDocumentByDefault: this.$store.state.businessSettings.showAllContactsInTaxDocumentByDefault,
        contactFormFieldsVisibility: this.$store.state.businessSettings.contactFormFieldsVisibility,
        sendContactUpdateNotifications: this.$store.state.businessSettings.sendContactUpdateNotifications,
        sendSmsOnNewLead: this.$store.state.businessSettings.sendSmsOnNewLead,
      }

      // מלאי והשכרות only — other businesses never send the key (nor see the block)
      if (this.hasInventoryAccess)
        saveData.inventoryReserveOn = this.$store.state.businessSettings.inventoryReserveOn || null;

      apiPost('business-settings', saveData);
    },


    validateMisimTab() {

      let errors = {};
      let valid = true;



      if (!this.$store.state.businessSettings.hetPey && !this.$store.state.businessSettings.numOsekMurshe) {
        errors.hetPey = 'נא להזין מספר ח.פ או עוסק מורשה תקין'
        errors.numOsekMurshe = 'נא להזין מספר ח.פ או עוסק מורשה תקין'

      } else {

        if (this.$store.state.businessSettings.hetPey && !this.$store.state.businessSettings.hetPey.toString().match(/^\d{9}$/)) {
          errors.hetPey = 'נא להזין מספר ח.פ תקין'
        }

        if (this.$store.state.businessSettings.numOsekMurshe && !this.$store.state.businessSettings.numOsekMurshe.toString().match(/^\d{9}$/)) {
          errors.numOsekMurshe = 'נא להזין מספר עוסק מורשה תקין'
        }

      }





      if (this.$store.state.businessSettings.numTikNihuim && !this.$store.state.businessSettings.numTikNihuim.toString().match(/^\d{9}$/))
        errors.numTikNihuim = 'נא להזין מספר תיק ניכויים תקין'

      if (this.$store.state.businessSettings.numHevraRashamHevrot && !this.$store.state.businessSettings.numHevraRashamHevrot.toString().match(/^\d{9}$/))
        errors.numHevraRashamHevrot = 'נא להזין מספר חברה תקין'


      // the bank account rows paint their own errors (BankAccountsEditor is always rendered - the tab
      // panes are shown / hidden by class, so the ref is there whichever tab is open)
      if (this.$refs.bankAccountsEditor)
        valid &= this.$refs.bankAccountsEditor.validate();


      if (!this.$store.state.businessSettings.taxDocument_startCount_lakuah || parseInt(this.$store.state.businessSettings.taxDocument_startCount_lakuah) <= 0) {
        errors.taxDocument_startCount_lakuah = 'נא להזין מספר תקין';
      }


      if (!this.$store.state.businessSettings.taxDocument_startCount_heshbonitMas || parseInt(this.$store.state.businessSettings.taxDocument_startCount_heshbonitMas) <= 0) {
        errors.taxDocument_startCount_heshbonitMas = 'נא להזין מספר תקין';
      }


      if (!this.$store.state.businessSettings.taxDocument_startCount_heshbonitMasKabala || parseInt(this.$store.state.businessSettings.taxDocument_startCount_heshbonitMasKabala) <= 0) {
        errors.taxDocument_startCount_heshbonitMasKabala = 'נא להזין מספר תקין';
      }


      if (!this.$store.state.businessSettings.taxDocument_startCount_heshbonitZikui || parseInt(this.$store.state.businessSettings.taxDocument_startCount_heshbonitZikui) <= 0) {
        errors.taxDocument_startCount_heshbonitZikui = 'נא להזין מספר תקין';
      }


      if (!this.$store.state.businessSettings.taxDocument_startCount_kabala || parseInt(this.$store.state.businessSettings.taxDocument_startCount_kabala) <= 0) {
        errors.taxDocument_startCount_kabala = 'נא להזין מספר תקין';
      }


      if (!this.$store.state.businessSettings.taxDocument_startCount_heshbonIska || parseInt(this.$store.state.businessSettings.taxDocument_startCount_heshbonIska) <= 0) {
        errors.taxDocument_startCount_heshbonIska = 'נא להזין מספר תקין';
      }


      if (!this.$store.state.businessSettings.taxDocument_startCount_hatsaatMehir || parseInt(this.$store.state.businessSettings.taxDocument_startCount_hatsaatMehir) <= 0) {
        errors.taxDocument_startCount_hatsaatMehir = 'נא להזין מספר תקין';
      }


      if (!this.$store.state.businessSettings.taxDocument_startCount_teudatMishloah || parseInt(this.$store.state.businessSettings.taxDocument_startCount_teudatMishloah) <= 0) {
        errors.taxDocument_startCount_teudatMishloah = 'נא להזין מספר תקין';
      }


      if (!this.$store.state.businessSettings.taxDocument_startCount_hazmana || parseInt(this.$store.state.businessSettings.taxDocument_startCount_hazmana) <= 0) {
        errors.taxDocument_startCount_hazmana = 'נא להזין מספר תקין';
      }


      if (!this.$store.state.businessSettings.taxDocument_startCount_heshbonIska || parseInt(this.$store.state.businessSettings.taxDocument_startCount_heshbonIska) <= 0) {
        errors.taxDocument_startCount_heshbonIska = 'נא להזין מספר תקין';
      }


      if (!this.$store.state.businessSettings.taxDocument_startCount_hazmanatRehesh || parseInt(this.$store.state.businessSettings.taxDocument_startCount_hazmanatRehesh) <= 0) {
        errors.taxDocument_startCount_hazmanatRehesh = 'נא להזין מספר תקין';
      }




      this.$set(this, "errors", errors);

      //this checks if there is at least one field with an error
      valid &= !Object.values(this.errors).some(value => value);

      if (!valid)
        planup.$globals.notifyFormError();

      return valid;
    },


    // Fetch the invoices still missing an allocation number and open the picker modal.
    openRetroAllocationModal() {
      this.$root.$emit('showSpinner');
      getMissingAllocation()
        .then(r => {
          this.$root.$emit('hideSpinner');
          const docs = (r.data && r.data.taxDocuments) || [];
          if (!docs.length) {
            this.$swal({ title: 'הכל מעודכן', text: 'אין חשבוניות הממתינות למספר הקצאה', type: 'success', confirmButtonColor: '#ab8ce4' });
            return;
          }
          // Default every row to selected ("do all"); the user can uncheck any that were already handled.
          this.retroInvoices = docs.map(d => Object.assign({}, d, { selected: true }));
          this.$refs.retroAllocationModal.show();
        })
        .catch(() => {
          this.$root.$emit('hideSpinner');
          this.$swal({ title: 'שגיאה', text: 'לא ניתן לטעון את רשימת החשבוניות', type: 'error', confirmButtonColor: '#ab8ce4' });
        });
    },

    retroSelectedCount() {
      return this.retroInvoices.filter(i => i.selected).length;
    },

    isAllRetroSelected() {
      return this.retroInvoices.length > 0 && this.retroInvoices.every(i => i.selected);
    },

    toggleSelectAllRetro(checked) {
      this.retroInvoices.forEach(i => { i.selected = checked; });
    },

    // Send allocation requests only for the checked invoices, then report.
    sendRetroSelected() {
      const ids = this.retroInvoices.filter(i => i.selected).map(i => i.id);
      if (!ids.length) return;
      this.$refs.retroAllocationModal.hide();
      requestAllocationForIds(this, ids);
    },

    docTypeLabel(type) {
      if (type === 'heshbonitMas') return 'חשבונית מס';
      if (type === 'heshbonitMasKabala') return 'חשבונית מס קבלה';
      return type;
    },

    formatInvoiceDate(d) {
      if (!d) return '';
      const date = new Date(d);
      if (isNaN(date.getTime())) return d;
      const dd = ('0' + date.getDate()).slice(-2);
      const mm = ('0' + (date.getMonth() + 1)).slice(-2);
      return dd + '/' + mm + '/' + date.getFullYear();
    },

    formatAmount(v) {
      const n = Number(v);
      if (isNaN(n)) return '';
      return '₪ ' + n.toLocaleString('he-IL', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },

    saveMisimTab() {


      if (!this.validateMisimTab())
        return;


      let saveData = {
        hetPey: this.$store.state.businessSettings.hetPey,
        numOsekMurshe: this.$store.state.businessSettings.numOsekMurshe,
        numTikNihuim: this.$store.state.businessSettings.numTikNihuim,
        numHevraRashamHevrot: this.$store.state.businessSettings.numHevraRashamHevrot,
        taxDocument_startCount_lakuah: this.$store.state.businessSettings.taxDocument_startCount_lakuah,
        taxDocument_startCount_heshbonitMas: this.$store.state.businessSettings.taxDocument_startCount_heshbonitMas,
        taxDocument_startCount_heshbonitMasKabala: this.$store.state.businessSettings.taxDocument_startCount_heshbonitMasKabala,
        taxDocument_startCount_heshbonitZikui: this.$store.state.businessSettings.taxDocument_startCount_heshbonitZikui,
        taxDocument_startCount_kabala: this.$store.state.businessSettings.taxDocument_startCount_kabala,
        taxDocument_startCount_heshbonIska: this.$store.state.businessSettings.taxDocument_startCount_heshbonIska,
        taxDocument_startCount_hatsaatMehir: this.$store.state.businessSettings.taxDocument_startCount_hatsaatMehir,
        taxDocument_startCount_teudatMishloah: this.$store.state.businessSettings.taxDocument_startCount_teudatMishloah,
        taxDocument_startCount_hazmana: this.$store.state.businessSettings.taxDocument_startCount_hazmana,
        taxDocument_startCount_heshbonIska: this.$store.state.businessSettings.taxDocument_startCount_heshbonIska,
        taxDocument_startCount_hazmanatRehesh: this.$store.state.businessSettings.taxDocument_startCount_hazmanatRehesh,
        bankAccounts: this.$store.state.businessSettings.bankAccounts,
        typeOfAccounting: this.selectedTypeOfAccounting.value,
        osekPatur: this.$store.state.businessSettings.osekPatur,
        hatsaatMehirSkipRequiredContactFields: !!this.$store.state.businessSettings.hatsaatMehirSkipRequiredContactFields,
        hatsaatMehirSignatureByDefault: !!this.$store.state.businessSettings.hatsaatMehirSignatureByDefault,
        alwaysRequireTeudatZehut: !!this.$store.state.businessSettings.alwaysRequireTeudatZehut,
        // Keep an explicit 0 ("request for all"); only an empty/absent field becomes null (=> code default 5000).
        heshboniotIsraelMinAmount: (this.$store.state.businessSettings.heshboniotIsraelMinAmount === '' || this.$store.state.businessSettings.heshboniotIsraelMinAmount == null) ? null : Number(this.$store.state.businessSettings.heshboniotIsraelMinAmount),

      }

      apiPost('business-settings', saveData);

    },

    uploadLogo() {
      var formData = new FormData();

      formData.append("file", this.$refs.uploadLogoFileInput.files[0]);

      apiPost("files/uploadLogo", formData).then(() => {
        this.$store.state.logoImageUrl += 7;
      }).catch(() => {
        this.$swal({
          type: 'error',
          title: 'שגיאה בהעלאת הלוגו',
          text: 'אירעה שגיאה בעת העלאת הקובץ. אנא נסה שנית.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      });
    },

    uploadSignature() {
      var file = this.$refs.uploadSignatureFileInput.files[0];

      if (!file) {
        return;
      }

      if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
        this.$refs.uploadSignatureFileInput.value = '';
        this.$swal({
          type: 'error',
          title: 'קובץ לא נתמך',
          text: 'ניתן להעלות חתימה בפורמט PNG או JPEG בלבד.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        return;
      }

      var formData = new FormData();

      formData.append("file", file);

      apiPost("files/uploadSignature", formData).then((data) => {
        this.$store.state.businessSettings.signature64 = data.signature64
        this.$store.state.businessSettings.signature64mimetype = data.signature64mimetype
      }).catch(() => {
        this.$swal({
          type: 'error',
          title: 'שגיאה בהעלאת החתימה',
          text: 'אירעה שגיאה בעת העלאת הקובץ. אנא נסה שנית.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      });
    },

    /**
     * Rebuilds the tenant's whole events table (search_result reconciliation).
     * Heavy and tenant-wide, so it's gated twice on purpose — a warning, then
     * typing the word — to keep it from being set off out of curiosity.
     */
    fixSearchResults() {
      this.$swal({
        title: 'הנשמה למערכת',
        html: 'פעולה זו סורקת ובונה מחדש את כל טבלת האירועים של העסק.<br><br>' +
          '<b style="color:#ff5370">להפעיל רק לפי הנחיה של התמיכה.</b><br>' +
          'הפעלה מיותרת מעמיסה על המערכת, והיא עלולה להיות איטית למשך מספר דקות.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'הבנתי, המשך',
        cancelButtonText: 'ביטול',
        confirmButtonColor: '#ff5370',
        focusCancel: true,
      }).then(() => {

        this.$swal({
          title: 'אישור אחרון',
          html: 'הקלידו <b>הנשמה</b> כדי להפעיל.',
          type: 'warning',
          input: 'text',
          inputPlaceholder: 'הנשמה',
          showCancelButton: true,
          confirmButtonText: 'הפעל',
          cancelButtonText: 'ביטול',
          confirmButtonColor: '#ff5370',
          inputValidator: (value) => {
            return new Promise((resolve, reject) => {
              if (value == 'הנשמה')
                resolve();
              else
                reject('יש להקליד "הנשמה" בדיוק');
            });
          },
        }).then(() => {

          this.$handlers.eventHandler._fixSearchResults();

          this.$swal({
            type: 'success',
            title: 'ההנשמה הופעלה',
            text: 'העדכון רץ ברקע ועשוי לקחת מספר דקות.',
            confirmButtonColor: '#ab8ce4',
          }).catch(() => { });

        }).catch(() => { });
      }).catch(() => { });
    },

    showCSVUploadModal(isPriceUpdate = false) {
      this.justPriceChangeCSV = isPriceUpdate;
      this.$refs.csvFormatModal.show();
    },

    uploadCSV() {
      var formData = new FormData();
      formData.append("file", this.$refs.uploadCSVfileInput.files[0]);

      // Quick fix for price change csv
      if (this.justPriceChangeCSV) {
        apiPost("importclients/addPrice", formData).then((d) => {
          console.log(d);
          this.$refs.csvFormatModal.hide();
          this.$swal({
            type: 'success',
            title: 'הקובץ הועלה בהצלחה',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          });
        });
        return;
      }

      apiPost("importclients", formData).then((d) => {
        console.log(d);
        this.$refs.csvFormatModal.hide();
        this.$swal({
          type: 'success',
          title: 'הקובץ הועלה בהצלחה',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      });
    },
  },
  components: {
    GoogleSettings,
    Multiselect,
    WhatsappTab,
    WheelTimePicker,
    BankAccountsEditor,
    LeadSourcesSettings,
    CalendarColorsSettings,
    HomeScreenSettings,
    PageBackgroundSettings,
    CustomerTabsBar,
    TaxAuthorityConnectionStatus
  },

  mounted() {


    if (this.$router.currentRoute.query.activeTab)
      this.activeTab = this.$router.currentRoute.query.activeTab;

    // no popup here any more: the tax details are asked for on the first finance screen of the
    // session (Onboarding/TaxDetailsPrompt.vue), and a link into a tab (?activeTab=) is never covered


    this.selectedTypeOfAccounting = this.typesOfAccounting.find(type => type.value == +this.$store.state.businessSettings.typeOfAccounting);

    // Load connected Facebook pages
    this.loadConnectedFacebookPages();

  },
};
</script>
<style>
.removeContactButton {
  position: relative;
  top: 8px;
  margin-right: 20px;
  font-size: 14px;
  display: inline-block;
  cursor: pointer;
  color: rgb(119, 119, 119)
}

.removeContactButton:hover {
  color: #ff5370
}

.dangerZone {
  text-align: center;
  padding: 25px 0 20px;
}

.dangerZoneTrigger {
  font-size: 11px;
  color: #dcdcdc;
  cursor: pointer;
  user-select: none;
  padding: 4px 9px;
  border-radius: 3px;
  transition: color .15s, background .15s, border-color .15s;
  border: 1px dashed transparent;
}

.dangerZoneTrigger i {
  font-size: 10px;
  margin-left: 3px;
}

/* Only on hover does it admit what it is */
.dangerZoneTrigger:hover {
  color: #ff5370;
  background: #ffe3ec;
  border-color: #ff5370;
}
</style>
